import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { CourseCardComponent } from '../../course-card/course-card.component';
import { CourseCardClearingBtnsComponent } from '../course-card-clearing-btns/course-card-clearing-btns.component';
import { ClientValidatorService } from '@uc/web/core';
import {
	ClientFeatureOptions,
	FeaturedClearing,
	FeaturedCalls,
	FeaturedRegisteredInterest,
	ClientFeatures,
	ProductEnum,
} from '@uc/web/shared/data-models';
import { CourseDetails } from '../../../models/course-search.models';
@Component({
	selector: 'uc-clearing-course-card-container',
	standalone: true,
	templateUrl: './clearing-course-card-container.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CourseCardComponent, CourseCardClearingBtnsComponent],
})
export class ClearingCourseCardContainerComponent implements OnInit {
	courses = input.required<CourseDetails[]>();
	clientFeatures = input.required<ClientFeatureOptions[]>();
	uniSlug = input.required<string>();
	uniId = input.required<number>();
	externalUrl = input.required<string>();
	phoneNumber = input.required<string | null>();
	uniName = input.required<string>();
	cleSearchOrderPosition = input.required<number>();
	privacyPolicyUrl = input.required<string | null>();
	searchTerm = input.required<string>();
	isHECoSSubject = input.required<boolean | null>();
	degreeLevel = input.required<string>();
	region = input.required<string>();
	productAbbr = 'cle';
	isFeatured!: FeaturedClearing;
	isFeaturedCalls!: FeaturedCalls;
	isFeaturedRegisterInterest!: FeaturedRegisteredInterest;

	readonly clearing = ProductEnum.Clearing;

	constructor(private _cvSrv: ClientValidatorService) {}

	ngOnInit() {
		this.isFeatured = this._cvSrv.checkFeature(
			this.clientFeatures(),
			ClientFeatures['Clearing'],
		);
		this.isFeaturedCalls = this._cvSrv.checkFeature(
			this.clientFeatures(),
			ClientFeatures.Calls,
		);
		this.isFeaturedRegisterInterest = this._cvSrv.checkFeature(
			this.clientFeatures(),
			ClientFeatures.RegisterInterest,
		);
	}
}
